import { BasketballLeaguesSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { Col, Row, Table, Typography } from 'antd';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';

export default function AddLeagueAssistentPreview() {
  const dispatch = useAppDispatch();
  const assistantState = useSelector(
    BasketballLeaguesSlice.basketballLeagueAssistentSelector
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchPreview();
  }, []);

  const fetchPreview = () => {
    const leagueId = assistantState.selectedLeague?.ligaId;
    const teams = assistantState.selectedTeams.map((t) => {
      return {
        season_team_id: t.season_team_id || 0,
      };
    });
    if (leagueId) {
      setLoading(true);
      dispatch(
        BasketballLeaguesSlice.fetchDbbBasketballLeaguePreview({
          league_id: leagueId,
          teams: teams,
        })
      )
        .unwrap()
        .then((data) => setData(data))
        .finally(() => setLoading(false));
    }
  };

  return (
    <Row>
      <Col xs={24}>
        <Typography.Paragraph>
          {t('leagues.assistant.check.info', { number: data.length })}
        </Typography.Paragraph>
        <Table
          loading={loading}
          columns={[
            {
              key: 'datetime',
              dataIndex: 'datetime',
              title: t('date'),
              render: (v) => formatDateTime(v),
            },
            {
              key: 'homeTeam',
              dataIndex: 'homeTeam',
              title: t('home'),
            },
            {
              key: 'guestTeam',
              dataIndex: 'guestTeam',
              title: t('guest'),
            },
          ]}
          dataSource={data}
        />
      </Col>
    </Row>
  );
}
